<script>
  import { theme } from "../store/theme.js";
  import { trackEvent } from "../util/analytics.js";
  export let link;
  export let tracking = true;

  let themeValue;
  theme.subscribe((value) => {
    themeValue = value;
  });
</script>

<a
  class={themeValue}
  href={link.href}
  on:click={() => tracking && trackEvent(link.title, "click")}
  target="_blank"
  rel="noopener noreferrer"
>
  <div class="bkg">
    <div class="logo-wrapper">
      {#if link.logo}
        {#if link.logo.includes("/")}
          <img class="icon" src={link.logo} alt={link.title} />
        {:else}
          <span class="icon">{link.logo}</span>
        {/if}
      {:else}
        <img class="icon" src="/img/iterbart.png" alt={link.title} />
      {/if}
    </div>
    {#if link.description}
      <p class="description">{link.description}</p>
    {/if}
  </div>
  <h2>{link.title}</h2>
</a>

<style>
  a {
    box-sizing: border-box;
    display: flex;
    align-items: center;
    flex-direction: column;
    position: relative;
    width: 100%;
    height: 16rem;
  }

  h2 {
    font-weight: 400;
    position: absolute;
    top: 10rem;
    transition: opacity 0.2s ease 0.2s, color 0.2s ease-out;
    color: inherit;
  }

  a:hover h2 {
    opacity: 0;
  }

  .description {
    margin-top: 0;
    width: 18rem;
  }

  .icon {
    width: 5rem;
    height: 5rem;
    object-fit: contain;
    padding: 2.5rem;
    font-size: 5rem;
    line-height: 1;
    display: block;
  }

  .logo-wrapper {
    width: 10rem;
    height: 10rem;
  }

  .bkg {
    width: 10rem;
    height: 10rem;
    border: 1px solid rgba(225, 227, 232, 0.18);
    box-shadow: 0 3px 4px 0 rgba(44, 71, 146, 0.25);
    background-color: #fff;
    border-radius: 100%;
    overflow: hidden;
    display: flex;
    flex-direction: column;
    align-items: center;
    transition: all 0.3s ease;
    position: absolute;
  }
  .dark .bkg {
    background-color: #1d1d1d;
    border: 1px solid rgba(0, 0, 0, 0.18);
    box-shadow: 0 3px 4px 0 rgba(0, 0, 0, 0.3);
  }
  a:focus {
    outline: none;
  }
  a:hover .bkg,
  a:focus .bkg {
    width: 20rem;
    height: 20rem;
    border-radius: 0.4rem;
    z-index: 10;
    transform: translateY(-3rem);
  }
</style>
